import { useRef } from "react";

interface OtpInputProps {
  length?: number;
  code: string;
  setCode: (code: string) => void;
}

export default function OtpInput({
  length = 4,
  code,
  setCode,
}: OtpInputProps) {
  const inputsRef = useRef<Array<HTMLInputElement | null>>([]);

  const handleChange = (value: string, index: number) => {
    if (!/^\d?$/.test(value)) return;

    const codeArray = code.split("");
    codeArray[index] = value;
    const newCode = codeArray.join("").padEnd(length, "");
    setCode(newCode);

    if (value && index < length - 1) {
      inputsRef.current[index + 1]?.focus();
    }
  };

  const handleKeyDown = (
    e: React.KeyboardEvent<HTMLInputElement>,
    index: number
  ) => {
    if (e.key === "Backspace" && !code[index] && index > 0) {
      inputsRef.current[index - 1]?.focus();
    }
  };

  return (
    <div className="flex gap-3 justify-center">
      {Array.from({ length }).map((_, i) => (
        <input
          key={i}
          ref={(el) => (inputsRef.current[i] = el)}
          type="text"
          inputMode="numeric"
          maxLength={1}
          value={code[i] || ""}
          onChange={(e) => handleChange(e.target.value, i)}
          onKeyDown={(e) => handleKeyDown(e, i)}
          className="w-[62px] h-10 rounded-[10px] text-center text-xl border-2 border-[#00000033] outline-none focus:border-[#0027CB] focus:ring-0"
        />
      ))}
    </div>
  );
}
